<template>
    <div class="c-table table-shop-products">
        <!-- Table head -->
        <div class="c-thead gap-1">
            <div class="c-td is-1" v-text="'Sklep'" />

            <div
                v-if="!product.ean_present"
                class="c-td is-2 d-flex"
                v-text="'Kod lokalny'"
            />

            <div v-if="!isMix" class="c-td is-2 d-flex">
                Cena w promocji

                <a-icon
                    v-if="isTypeWeight"
                    icon="Info"
                    :style="'min-width: 24px'"
                    v-tooltip="'Cena za kilogram'"
                />
            </div>

            <div class="c-td is-3" v-text="'Cena poza promocją'" />
        </div>

        <!-- Table body -->
        <div class="c-tbody">
            <shop-prices
                v-for="merchant in merchants"
                :product="product"
                :merchant="merchant"
                :key="merchant.id"
            />
        </div>
    </div>
</template>

<script>
import { addNewPromo } from '@/mixins/addNewPromo'
import ShopPrices from './ShopPrices.vue'

export default {
    mixins: [addNewPromo],

    components: {
        ShopPrices
    },

    props: {
        merchants: {
            type: Array,
            required: true
        },

        product: {
            type: Object,
            required: true
        }
    }
}
</script>
